import * as a0 from "@take-2/assets/versions" with { type: "json" }
let a0_ = "" + void a0;
import '@take-2/views/layouts/player.client.ts';
import '@take-2/views/layouts/player.client.css';
import '@take-2/views/video/player/desktop.client.css';
import '@take-2/views/video/player/desktop.client.ts';